export default __webpack_public_path__ + "static/media/redBullet.c8ea0023.svg";